import { useTranslation } from "react-i18next";
import { Wrench } from "@phosphor-icons/react";

export default function LegalPlaceholder({
  titleKey,
  testId,
  kickerKey = "legal.kicker",
  messageKey = "legal.in_construction",
}) {
  const { t } = useTranslation();
  return (
    <main
      data-testid={testId}
      className="min-h-[70vh] flex items-center justify-center px-6 md:px-12 pt-28 pb-20"
    >
      <div className="max-w-xl text-center">
        <span className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-slate-100 mb-6">
          <Wrench size={26} weight="regular" className="text-slate-500" />
        </span>
        <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-slate-500">
          {t(kickerKey)}
        </p>
        <h1 className="mt-3 font-heading text-3xl md:text-4xl font-bold tracking-tight text-slate-900">
          {t(titleKey)}
        </h1>
        <p className="mt-5 text-base leading-relaxed text-slate-600">
          {t(messageKey)}
        </p>
      </div>
    </main>
  );
}
